import axios from "../../../util/axios";

const PREFIX_URI = "/project/dev/statistics";

export default {
    /** 延期统计总览（汇总 + 多维度 + 明细，按 delay_status 取数） */
    overview: (data) => axios.get({url: `${PREFIX_URI}/overview`, data: data}),
    /** 所属项目下拉选项 */
    queryProjectOptions: () => axios.get({url: `${PREFIX_URI}/queryProjectOptions`}),
};
